<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="650">
    <v-card>
      <v-card-text class="pt-6">
        <v-alert text type="info"
          >Por favor, atualize suas informações antes de utilizar o
          portal</v-alert
        >
        <atualizacao-dados-pessoais :back_on="false" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AtualizacaoDadosPessoais from "../atualizacao-cadastral/AtualizacaoDadosPessoais.vue";
export default {
  components: { AtualizacaoDadosPessoais },  
  data: () => ({
    dialog: true,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>